// src/componentes/comunes/AvisoActualizacion.js
import React from 'react';

/**
 * Banner fijo que aparece cuando hay una nueva versión del app disponible.
 * Al tocar "Actualizar", envía SKIP_WAITING al SW nuevo y recarga la página.
 */
export const AvisoActualizacion = ({ mostrar, onActualizar }) => {
  if (!mostrar) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: 'var(--ag-texto)',
      color: 'var(--ag-superficie)',
      padding: '0.875rem 1.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      boxShadow: 'var(--ag-sombra-3)'
    }}>
      <span style={{ fontSize: "calc(0.875rem * var(--escala-tipografia, 0.85))", lineHeight: 1.4 }}>
        Nueva versión disponible
      </span>
      <button
        onClick={onActualizar}
        style={{
          background: 'var(--ag-superficie)',
          color: 'var(--ag-texto)',
          border: 'none',
          borderRadius: 'var(--ag-radio)',
          padding: '0.5rem 1.25rem',
          fontSize: "calc(0.875rem * var(--escala-tipografia, 0.85))",
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          fontFamily: 'inherit'
        }}
      >
        Actualizar
      </button>
    </div>
  );
};
